import { Grid, Typography } from '@mui/material';
import { styled } from 'styled-components';

export const MfaListHeader = styled(Grid)`
  font-size: 1.1rem;
  font-weight: 600;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.grey[500]};
  width: 100%;
  overflow: hidden;
  border-bottom: none;
`;

export const MfaListContainer = styled(Grid)`

  & > *:first-child {
    border-top-left-radius: 1em;
    border-top-right-radius: 1em;
  }

  & > *:last-child {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[500]};
  }
`;

export const MfaListItem = styled(Grid)`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.grey[500]};
  width: 100%;
  overflow: hidden;
  border-bottom: none;
`;

export const MfaListMethodTitle = styled(Typography)`
  font-size: 1.1rem;
  font-weight: 600;
`;

export const MfaListMethodDescription = styled(Typography)`
  font-size: 0.8rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
